import type { AllRouteEndpoints } from "../routeTypes";

export const engagementSqlSegmentCohortAccountUsage = "/engagement/api/segment_cohorts/current_billing_cycle";
export const sqlSegmentCohortAccountUsageCacheKeys: AllRouteEndpoints[] = [
  "/engagement/api/segment_cohorts/current_billing_cycle",
];
